import { forwardRef } from 'react';
import { BaseButtonProps } from '../types';
import { IconButton as MuiIconButton } from '@mui/material';

export interface IconButtonProps extends BaseButtonProps {}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  return <MuiIconButton ref={ref} {...props} />;
});

IconButton.displayName = 'IconButton';

export default IconButton;
